<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="titlePage" id="tp01">
<a id="page03"></a>
<h2 class="titlePageTitle"><span class="bold">VIOLENT POLITICS</span></h2>
<p class="titlePageSubtitle">A HISTORY OF<br/> INSURGENCY,<br/> TERRORISM &amp;<br/> GUERRILLA WAR,<br/> FROM THE <br/>AMERICAN <br/>REVOLUTION <br/>TO IRAQ</p>
<h2 class="titlePageAuthor"><span class="bold">WILLIAM R. POLK</span></h2>
<p class="titlePageLogo"><img alt="image" src="logo.jpg"/></p>
</div>
<div class="dedicationPage" id="ded01">
<a id="page04"></a>
<a id="page05"></a>
<p class="dedicationTextCenter">F<span class="smallCaps">OR</span> E<span class="smallCaps">LISABETH WITH LOVE</span></p>
<a id="page06"></a>
</div>
<div class="contents" id="con01">
<a id="page11"></a>
<h2 class="contentsHead"><span class="bold">CONTENTS</span></h2>
<div class="contentsEntry" id="fm_01">
<p class="contentsEntryName"><a href="#/introduction#fm01">Introduction</a></p></div>
<br/>
<div class="contentsEntry1" id="ch_01">
<p class="contentsEntryNumber"><a href="#/chapter01#ch01">1 The American Insurgency</a></p></div>
<div class="contentsEntry1" id="ch_02">
<p class="contentsEntryNumber"><span href="#/chapter02#ch02" title="Link target outside of Sample">2 The Spanish <em class="italic">Guerrilla</em> Against the French</span></p></div>
<div class="contentsEntry1" id="ch_03">
<p class="contentsEntryNumber"><span href="#/chapter03#ch03" title="Link target outside of Sample">3 The Philippine “Insurrection”</span></p></div>
<div class="contentsEntry1" id="ch_04">
<p class="contentsEntryNumber"><span href="#/chapter04#ch04" title="Link target outside of Sample">4 The Irish Struggle for Independence</span></p></div>
<div class="contentsEntry1" id="ch_05">
<p class="contentsEntryNumber"><span href="#/chapter05#ch05" title="Link target outside of Sample">5 Tito and the Yugoslav Partisans</span></p></div>
<div class="contentsEntry1" id="ch_06">
<p class="contentsEntryNumber"><span href="#/chapter06#ch06" title="Link target outside of Sample">6 The Greek Resistance</span></p></div>
<div class="contentsEntry1" id="ch_07">
<p class="contentsEntryNumber"><span href="#/chapter07#ch07" title="Link target outside of Sample">7 Kenya and the Mau Mau</span></p></div>
<div class="contentsEntry1" id="ch_08">
<p class="contentsEntryNumber"><span href="#/chapter08#ch08" title="Link target outside of Sample">8 The Algerian War of National Independence</span></p></div>
<div class="contentsEntry1" id="ch_09">
<p class="contentsEntryNumber"><span href="#/chapter09#ch09" title="Link target outside of Sample">9 The Vietnamese Struggle Against the French</span></p></div>
<div class="contentsEntry1" id="ch_10">
<p class="contentsEntryNumber"><span href="#/chapter10#ch10" title="Link target outside of Sample">10 America Takes Over from France in Vietnam</span></p></div>
<div class="contentsEntry1" id="ch_11">
<p class="contentsEntryNumber"><span href="#/chapter11#ch11" title="Link target outside of Sample">11 The Afghan Resistance to the British and the Russians</span></p></div>
<br/>
<div class="contentsEntry1" id="bm_01">
<p class="contentsEntryName"><span href="#/conclusion#bm01" title="Link target outside of Sample">Conclusion: The Very Expensive School</span></p></div>
<div class="contentsEntry1" id="en_01">
<p class="contentsEntryName"><span href="#/notes#en01" title="Link target outside of Sample">Notes</span></p></div>
<div class="contentsEntry1" id="bm_02">
<p class="contentsEntryName"><span href="#/searchableterms#bm02" title="Link target outside of Sample">Searchable Terms</span></p></div>
<div class="contentsEntry1" id="ack_01">
<p class="contentsEntryName"><span href="#/acknowledgments#ack01" title="Link target outside of Sample">Acknowledgments</span></p></div>
<div class="contentsEntry1" id="ata_01">
<p class="contentsEntryName"><span href="#/abouttheauthor#ata01" title="Link target outside of Sample">About the Author</span></p></div>
<div class="contentsEntry1" id="rev_01">
<p class="contentsEntryName"><span href="#/praise#rev01" title="Link target outside of Sample">Praise</span></p></div>
<div class="contentsEntry1" id="adc_01">
<p class="contentsEntryName"><span href="#/otherbooks#adc01" title="Link target outside of Sample">Other Books by William R. Polk</span></p></div>
<div class="contentsEntry1" id="cop_01">
<p class="contentsEntryName"><span href="#/copyright#cop01" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName"><span href="#/aboutthepublisher#atp01" title="Link target outside of Sample">About the Publisher</span></p></div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// violentpolitics.vue?a1bab756